import { createFileRoute } from "@tanstack/react-router"
import { lazy } from "react"
import LazyRoutePage from "../../../-LazyRoutePage"

const WarehousePage = lazy(
  () => import("../../../../components/WMS/Warehouses/WarehousePage.tsx"),
)

export const Route = createFileRoute("/_layout/WMS/warehouses/$warehouse")({
  component: WarehouseRoute,
})

function WarehouseRoute() {
  return (
    <LazyRoutePage>
      <WarehousePage />
    </LazyRoutePage>
  )
}
